<template>
  <div class="knapp-checkbox">
    
    <v-simple-checkbox v-if="isSimple" v-model="value" :disabled="disabled" :dense="true" :color="elColor" />
    <v-checkbox v-else v-model="value" :hideDetails="hideDetails" :label="label" :disabled="disabled" :dense="true" :color="elColor" />
  </div>
</template>

<script>
export default {
  name: "Checkbox",
  props: {
    value: {
      type: Boolean,
    },
    color: {
      type: String,
    },
    isSimple:{
      type: Boolean,
      default: true,
    },
    label:{
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hideDetails:{
      type: Boolean,
    }
  },
  computed: {
    elColor() {
      if (!this.color) return "primary";
      return this.color;
    },
  },
  watch: {
    value: {
      handler(value) {
        this.$emit("updatedValue", value);
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.knapp-checkbox  {
  & > * {
    font-size: 22px !important;
  }
}
</style>
